import { render } from "./Bubbles.vue?vue&type=template&id=0a03280d&lang=pug"
import script from "./Bubbles.vue?vue&type=script&lang=js"
export * from "./Bubbles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__